module.exports = __webpack_public_path__ + "img/sk.18c27a5f.png";